import OverviewCardHeader from "../Overview/OverviewCardHeader";
import OverviewEmptyState from "../Overview/OverviewEmptyState";
import { Monitor } from "lucide-react";
import { Card, CardContent } from "../../ui/card";
import { RiskyMachineData } from "../interfaces/CommonInterfaces";

export default function OverviewRiskyMachines({
  riskyMachines,
  loading,
  fromdetails = false,
}: {
  riskyMachines: RiskyMachineData[];
  loading: boolean;
  fromdetails?: boolean;
}) {
  const sortedRiskyMachines = [...riskyMachines].sort(
    (a, b) => b.alertCount - a.alertCount,
  );

  // Skeleton loader for a machine item
  const renderSkeletonItem = (key: number) => (
    <div
      key={key}
      className="flex items-center justify-between p-2 border rounded-md bg-background/50 animate-pulse"
    >
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-gray-300 rounded-full" />
        <div className="w-32 h-4 bg-gray-300 rounded" />
      </div>
      <div className="space-y-1 text-right">
        <div className="w-6 h-4 mx-auto bg-gray-300 rounded" />
        <div className="w-10 h-3 mx-auto bg-gray-300 rounded" />
      </div>
    </div>
  );

  return (
    <Card className="overview-card analytics-risk-card">
      <OverviewCardHeader
        fromdetails={fromdetails}
        title="Risky Machines"
        description="Machines ranked by alert volume"
        icon={Monitor}
      />
      <CardContent className="overview-card-content">
        <div className="analytics-risk-list space-y-3">
          {loading && [...Array(5)].map((_, idx) => renderSkeletonItem(idx))}

          {!loading &&
            riskyMachines.length === 0 &&
            (fromdetails ? (
              <OverviewEmptyState
                icon={Monitor}
                message="No risky machines found."
              />
            ) : (
              <div className="py-8 text-sm text-center text-muted-foreground">
                No risky machines found.
              </div>
            ))}

          {!loading &&
            riskyMachines.length > 0 &&
            sortedRiskyMachines.map((machine) => (
              <div
                key={machine.id}
                className="analytics-risk-row flex items-center justify-between p-2 border rounded-md bg-background/50 hover-elevate"
              >
                <div className="flex items-center gap-2">
                  <Monitor className="w-4 h-4 text-muted-foreground" />
                  <span className="text-sm font-medium">
                    {machine.computerName}
                  </span>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium">
                    {machine.alertCount}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {machine.percentage}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </CardContent>
    </Card>
  );
}
